module.exports = __webpack_public_path__ + "media/images/down-155788940aa71bb68208224b5fd8b5bf.png";